/* stylelint-disable no-descending-specificity */
import styled from 'styled-components';
import { white, gray40, gray60, gray75, gray85
/** Light theme hover */
, green, greenLight, spacer16, spacer20 } from '@spotify-internal/encore-foundation';
import { colors, getColorOrDefault } from "../../styles/theme";
import { cursorDisabled } from "../../styles";
import Indicator from "./Indicator";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.formToggle === 'dark';
};
/** Basic styles */


export default styled.span.withConfig({
  displayName: "Wrapper",
  componentId: "sc-1hvt8s-0"
})(["background-color:", ";border-radius:11px;height:", ";position:relative;width:30px;input:focus ~ &,input:active:not([disabled]) ~ &{outline:none;box-shadow:0 0 0 2px ", ";}input:hover:not([disabled]):not(:active):not(:focus) ~ &{background-color:", ";}input:checked:hover:not([disabled]):not(:active):not(:focus) ~ &{background-color:", ";}input:active:not([disabled]) ~ &{", "{width:", ";}}input:checked ~ &{background-color:", ";", "{right:2px;left:auto;background-color:", ";}}input:disabled ~ &{opacity:0.4;cursor:", ";}"], function (props) {
  return isDarkTheme(props) ? gray40 : gray75;
}, spacer16, function (props) {
  return getColorOrDefault(props.theme, colors.primaryColorOutline, 'rgba(29, 185, 84, 0.2)');
}, function (props) {
  return isDarkTheme(props) ? gray60 : gray85;
}, function (props) {
  return getColorOrDefault(props.theme, colors.primaryColorHover, greenLight);
}, Indicator, spacer20, function (props) {
  return getColorOrDefault(props.theme, colors.primaryColor, green);
}, Indicator, white, cursorDisabled);